import { Controller, useFormContext } from 'react-hook-form';

import { useCountries } from '~shared/hooks';

import { Checkbox, InputMoney, RadioGroup, Select } from '@breeze/rhf-adapters';

import type { FinancesFormValues } from '..';
import {
  OFW_INCOME_AMOUNT_REQUIRED_ERROR,
  SELECT_REQUIRED_ERROR,
} from '../constants/field-errors';
import {
  OFW_COUNTRY_OF_WORK_FIELD_NAME,
  OFW_INCOME_AMOUNT_FIELD_NAME,
  OFW_INCOME_FREQUENCY_FIELD_NAME,
  OFW_RELATIONSHIP_FIELD_NAME,
  OFW_RELATIONSHIP_QA_LABEL,
  OFW_RELATIONSHIP_QUESTION_FIELD_NAME,
} from '../constants/field-names';
import { ofwIncomeFrequencyOptions } from '../lib/ofw-income-frequency-options';
import { ofwRelationshipOptions } from '../lib/ofw-relationship-options';

export const FinancesOFW = () => {
  const { control, watch } = useFormContext<FinancesFormValues>();
  const haveIncomeFromOFW = watch('haveIncomeFromOFW');

  const { countries, isLoading: isCountriesLoading } = useCountries();

  return (
    <>
      <Controller
        name="haveIncomeFromOFW"
        control={control}
        render={(fieldProps) => (
          <Checkbox {...fieldProps}>{OFW_RELATIONSHIP_FIELD_NAME}</Checkbox>
        )}
      />
      {haveIncomeFromOFW && (
        <>
          <p className="text-s text-text-secondary mb-2 leading-5">
            {OFW_RELATIONSHIP_QUESTION_FIELD_NAME}
          </p>
          <Controller
            name="ofwRelationship"
            control={control}
            rules={{ required: SELECT_REQUIRED_ERROR }}
            render={(fieldProps) => {
              return (
                <RadioGroup
                  {...fieldProps}
                  options={ofwRelationshipOptions}
                  qaLabel={OFW_RELATIONSHIP_QA_LABEL}
                  wide
                  vertical
                />
              );
            }}
          />
          <Controller
            name="ofwIncomeCountry"
            control={control}
            rules={{ required: SELECT_REQUIRED_ERROR }}
            render={(fieldProps) => (
              <Select
                label={OFW_COUNTRY_OF_WORK_FIELD_NAME}
                options={countries}
                withSearch
                loading={isCountriesLoading}
                {...fieldProps}
              />
            )}
          />
          <Controller
            control={control}
            name="ofwIncomeAmount"
            rules={{
              required: OFW_INCOME_AMOUNT_REQUIRED_ERROR,
            }}
            render={(fieldProps) => (
              <InputMoney
                {...fieldProps}
                label={OFW_INCOME_AMOUNT_FIELD_NAME}
                currency="PHP"
                currencyInValue
                symbolPosition="prefix"
                digitGroupingSeparator=","
                maxLength={11} // Includes digitGroupingSeparator
              />
            )}
          />
          <Controller
            name="ofwIncomeFrequency"
            control={control}
            rules={{ required: SELECT_REQUIRED_ERROR }}
            render={(fieldProps) => (
              <Select
                label={OFW_INCOME_FREQUENCY_FIELD_NAME}
                options={ofwIncomeFrequencyOptions}
                {...fieldProps}
              />
            )}
          />
        </>
      )}
    </>
  );
};
